import { CreateEventRuleBasicInformationForm } from './steps-form/create-event-rule-basic-information-form';
import { CreateEventRuleConditionsForm } from './steps-form/create-event-rule-conditions-form.tsx';
import { EventRuleMessageTemplateForm } from '../shared/event-rule-message-template-form.tsx';
import { CreateEventRuleOtherOptionsForm } from './steps-form/create-event-rule-other-options-form.tsx';
import {
  basicInformationFormSchema,
  conditionsFormSchema,
  messageTemplateFormSchema,
  otherOptionsFormSchema,
} from '@/features/event-rules/schemas/create-event-rules.schema.ts';

export const CREATE_EVENT_RULES_STEPS = [
  {
    step: 1,
    title: 'Basic Information',
    Element: CreateEventRuleBasicInformationForm,
    schema: basicInformationFormSchema,
  },
  {
    step: 2,
    title: 'Conditions',
    Element: CreateEventRuleConditionsForm,
    schema: conditionsFormSchema,
  },
  {
    step: 3,
    title: 'Event Description',
    Element: EventRuleMessageTemplateForm,
    schema: messageTemplateFormSchema,
  },
  {
    step: 4,
    title: 'Other options',
    Element: CreateEventRuleOtherOptionsForm,
    schema: otherOptionsFormSchema,
  },
] as const;
